import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
  }),
  response: z.void(),
};
